import classNames from "classnames";
import {
  Container,
  Heading3,
  Heading5,
  ImageLite,
  Paragraph,
} from "shared/components";

import styles from "./Content018.module.scss";

export const Content018 = ({ payload }) => {
  const title = payload?.title ?? "";
  const subTitle = payload?.subTitle ?? "";
  const date = payload?.date ?? "";
  const description = payload?.description ?? "";
  const image = payload?.preview ?? {};
  const appearance = payload?.template ?? "light";

  return (
    <div className={classNames(styles.wrapper, styles[appearance])}>
      <Container className={styles.inner}>
        <div className={styles.block}>
          <div className={styles.content}>
            <Heading3 className={styles.title}>{title}</Heading3>
            <Paragraph className={styles.date} color="brand">
              {date}
            </Paragraph>
            <Heading5 className={styles.subtitle}>{subTitle}</Heading5>
            <Paragraph className={styles.description} color="dark">
              {description}
            </Paragraph>
          </div>
          <div className={styles.preview}>
            <ImageLite image={image} className={styles.image} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content018;
